// @flow

import { blockCnDashboardActions } from '../../../blockCN/dashboard/blockCNDashboardRedux/blockCNDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  dashboardDataFiltered: [],
  error: null
};

const filterDashboardTableData = (newState, searchStr) => {
  const searchString = searchStr.trim();

  let filteredArr;

  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        (row.cnote &&
          row.cnote.toString() &&
          row.cnote.toString().indexOf(searchString) >= 0) ||
        (row.clientCode &&
          row.clientCode.toString() &&
          row.clientCode
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.clientName &&
          row.clientName.toString() &&
          row.clientName
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.reason &&
          row.reason.toString() &&
          row.reason
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.lastUpdatedByUser &&
          row.lastUpdatedByUser.name &&
          row.lastUpdatedByUser.name
            .toString()
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0)
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const blockCnDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case blockCnDashboardActions.SET_TRACK_DASHBOARD_DATE_RANGE: {
      return Object.assign({}, state, action.payload);
    }
    case blockCnDashboardActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case blockCnDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = Object.assign({}, state);
      const filtered = filterDashboardTableData(newState, action.payload);
      return Object.assign({}, state, { dashboardDataFiltered: filtered });
    }
    case blockCnDashboardActions.UNBLOCKED_CNS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default blockCnDashboardReducer;
